import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const bestPetSuppliesPicksStylesUS: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_APPBAR_BG: 'bg-[#3bbca3]',
  COMMONS_FOOTER_BG: 'bg-[#3bbca3]',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#3bbca3] hover:border-[#3bbca3] hover:bg-[#3bbca3]  text-white',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#3bbca3]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#3bbca3]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#3bbca3]',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#3bbca3] text-[#3bbca3] [&>svg>path]:stroke-[#3bbca3] [&>svg>g>path]:stroke-[#3bbca3] [&>svg>path]:fill-[#3bbca3] [&>svg>g>path]:fill-[#3bbca3]',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#3bbca3] text-[#3bbca3] [&>svg>path]:stroke-[#086d6d] [&>svg>g>path]:stroke-[#086d6d] [&>svg>path]:fill-[#086d6d] [&>svg>g>path]:fill-[#086d6d]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#3bbca3]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#3bbca3]',
  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#3bbca3]',
  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#3bbca3]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#3bbca3]',
  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#064b4b] [&>.vector-top>path]:fill-[#3bbca3] [&>.vector-bottom>path]:fill-[#3bbca3]',
  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#064b4b] [&>circle]:stroke-[#064b4b] [&>path]:fill-[#3bbca3]',
  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#086d6d] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#086d6d] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_LINK: 'text-[#086d6d]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#086d6d] [&_path]:fill-[#086d6d] [&_path]:stroke-[#086d6d]',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-[#086d6d]',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#086d6d]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#086d6d]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#086d6d]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#086d6d]',
  LISTPAGE_USER_VALUE_BADGE: 'text-gray-900 [&>div>svg>path]:fill-[#030303] bg-[#064b4b]',
  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#064b4b]',
  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#064b4b]',
  LISTPAGE_BADGE_WINNER_BG: 'bg-[#064b4b]',
  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-white',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-white',
  LISTPAGE_BADGE_SPONSORED_BG: 'bg-[#28a5a5]',
  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-[#28a5a5] text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#28a5a5]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#28a5a5]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#28a5a5]',

  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: 'text-white',
}
